module.exports = __webpack_public_path__ + "static/media/calendar-icon-white.46927c4a.svg";